import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import styled from '@emotion/styled';
import orderBy from 'lodash/orderBy';
import filter from 'lodash/filter';
import { adjustHue } from 'polished';
import { view } from 'react-easy-state';

import { getNodes } from '../../utils';

import Grid from '../grid/grid';
import Friend from './friend';
import { colors } from '../../styles/theme';
import mq from '../../styles/mq';
import { SubTitle } from '../elements';

export default view(() => (
  <StaticQuery
    query={graphql`
      query FriendsQuery {
        friends: allWordpressWpFriends {
          edges {
            node {
              id
              title
              content
              menu_order
              categories: friend_categories
              featured_media {
                source_url
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 500) {
                      ...GatsbyImageSharpFluid_tracedSVG
                    }
                  }
                }
              }
              acf {
                homepage
                facebook
                instagram
                twitter
                youtube_channel
                video
                bg_color
                bg_color_2
                bg_image
                link
              }
            }
          }
        }
        categories: allWordpressWpFriendCategories(filter: { name: { ne: "Uncategorized" } }) {
          edges {
            node {
              id
              wordpress_id
              slug
              name
              description
              count
            }
          }
        }
      }
    `}
    render={data => <Friends data={data} />}
  />
));

// const sortByColor = (friends) => {
//   const byHue = (friend) => {
//     const { hue } = parseToHsl(friend.acf.bg_color);
//     return hue;
//   };
//   const byLum = (friend) => {
//     const { lightness } = parseToHsl(friend.acf.bg_color);
//     return lightness;
//   };

//   return orderBy(friends, [byHue], ['desc']);
// };

@view
class Friends extends React.Component {
  render() {
    const { data } = this.props;

    const categories = orderBy(getNodes(data.categories), 'count', 'desc').map((cat) => {
      const friends = filter(
        orderBy(getNodes(data.friends), 'menu_order'),
        // sortByColor(getNodes(data.friends)),
        friend => friend.categories[0] === cat.wordpress_id
      );

      return {
        ...cat,
        friends,
      };
    });

    return (
      <>
        {categories.map(
          cat => cat.friends && (
          <Category className="site-section" id={cat.slug} key={cat.id}>
            <div className="section">
              <div className="container">
                <div
                  css={mq({
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    fontSize: ['2rem', '2.25rem', '2.5rem', '2.75rem'],
                  })}
                >
                  <CatCount>{cat.count}</CatCount>
                  <CatTitle>
                    {cat.name}
                    {cat.count > 1 && 's'}
                  </CatTitle>
                  <CategoryPalette colors={cat.friends.map(f => f.acf.bg_color)} />
                </div>
                <SubTitle
                  css={mq({
                    maxWidth: '50rem',
                    marginTop: '1.5rem',
                  })}
                  dangerouslySetInnerHTML={{ __html: cat.description }}
                />
              </div>
            </div>

            <Grid
              data={cat.friends}
              zoomSlide
                  // style={{
                  //   transformOrigin: 'top left',
                  //   transform: 'scale(0.2)',
                  // }}
              render={({ item, ...props }) => <Friend friend={item} {...props} />}
            />
          </Category>
          )
        )}
      </>
    );
  }
}

const Category = styled.div`
  position: relative;
  padding-bottom: 3rem;
`;

const CatTitle = styled.h3`
  font-size: 0.8em;
  margin-bottom: -0.35rem;
  padding-right: 0.75rem;
  display: inline;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.05em;
  text-transform: uppercase;
`;

const CatCount = styled.span`
  position: relative;
  display: inline-block;
  font-size: 1.5em;
  font-weight: 300;
  padding-right: 0.75rem;
  letter-spacing: -0.1em;
  line-height: 1;
  color: ${colors.primary};

  &:after {
    content: '';
    position: absolute;
    right: -10px;
    bottom: 0;
    height: 2px;
    width: 3000px;
    background: linear-gradient(to left, transparent, ${colors.pr.gray300} 20px);
  }
`;

class CategoryPalette extends React.Component {
  render() {
    const { colors } = this.props;

    return (
      <PaletteWrapper>
        {colors.map((color, i) => (
          <Color key={i} color={color} />
        ))}
      </PaletteWrapper>
    );
  }
}

const PaletteWrapper = styled.div`
  ${mq({
    display: ['none', 'flex'],
  })}
  align-items: flex-end;
  ${'' /* margin: 0 0 1.8rem; */}
`;

const Color = styled.div`
  position: relative;
  top: 2px;
  background: ${p => p.color};
  background-image: linear-gradient(to bottom, ${p => adjustHue(30, p.color)}, ${p => p.color});
  width: 0.4em;
  height: 0.65em;
  margin-right: 1px;
`;
